import React, { RefObject } from "react";
import { FormattedMessage } from "react-intl";

import { BaseError } from "@apps/mf-overview/src/ts/components/errors/BaseError";

/**
 * Error message that'll be displayed if the user attempted to load a page
 * that couldn't be found.
 */
// tslint:disable-next-line variable-name
export const PageNotFound = (props: {
  ref?: RefObject<HTMLDivElement | null>;
}) => {
  const errorMessage = (
    <FormattedMessage
      id="ErrorMessages__PageNotFound"
      defaultMessage="Vi kan desværre ikke finde den side du søgte efter."
    />
  );

  return <BaseError ref={props.ref} errorMessage={errorMessage} />;
};
